import SlimSelect from 'slim-select';
import {dataObject} from 'slim-select/dist/data';

export default class ProductSelectorController {
  private readonly productSelector = '.js-productSelector';
  private productSelectorController: NodeListOf<HTMLSelectElement> | null = document.querySelectorAll(
    this.productSelector,
  );

  constructor() {
    this.productSelectorController?.forEach(
      (el: HTMLSelectElement): void => {
        el.addEventListener('change', this.setGoto);
        // init
        el.dispatchEvent(new Event('change'));

        // add our icon from "data-icon-uri"
        const data: dataObject[] = Array.from(el.options).map(
          (e: HTMLOptionElement, i: number) => <dataObject>{
            innerHTML: `<img alt="" src="${e.dataset.iconUri}"> ${e.text}`,
            value: e.value,
            text: e.text,
            selected: i === 0, // auto-select first
          },
        );

        new SlimSelect({
          select: el,
          showSearch: false,
          data: data,
        });
      },
    );
  }

  setGoto(event: Event) {
    const selectElem = <HTMLSelectElement>event.currentTarget;
    const controls = <HTMLLinkElement>document.getElementById(
      selectElem.getAttribute('aria-controls') ?? '',
    );
    controls.href = selectElem.value;
  }
}
